<template>
  <div id="item-metocean">
    <div>
      <vs-row vs-type="flex" class="mt-4">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="4"
        >
          <span class="aisea-text-14-400-white">海象</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="8"
        >
          <vs-switch v-model="showMetocean" :color="AISEA_COLOR.BLUE"/>
        </vs-col>
      </vs-row>
    </div>

    <vs-divider class=" mb-0" :color="AISEA_COLOR.GRAY"/>

    <vs-row v-for="(element, index) in elements"
            :key="index" vs-type="flex" class="mt-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="12"
      >
        <input type="radio" class="blue" :value="element.value" v-model="selectedElements" :disabled="!showMetocean">
        <div class="metocean-radio-flex-container" @click="setSelectedElements(element.value)">
          <img class="ml-4" :src="element.icon">
          <span class="aisea-text-14-400-white ml-4">{{
              element.label
            }}</span>
        </div>
      </vs-col>
    </vs-row>

    <vs-divider class=" mb-0" :color="AISEA_COLOR.GRAY"/>

    <vs-row vs-type="flex" class="mt-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="4"
      >
        <span class="aisea-text-14-400-white">数値表示</span>
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-w="8"
      >
        <vs-switch v-model="showElementValue" :disabled="!showMetocean" :color="AISEA_COLOR.BLUE"/>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" class="mt-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="4"
      >
        <span class="aisea-text-14-400-white">グリッド表示</span>
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-w="8"
      >
        <vs-switch v-model="showGrid" :disabled="!showMetocean" :color="AISEA_COLOR.BLUE"/>
      </vs-col>
    </vs-row>

    <vs-divider class=" mb-0" :color="AISEA_COLOR.GRAY"/> 

      <!-- 更正海面気圧線 -->
    <vs-row vs-type="flex" class="mt-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="4"
      >
        <span class="aisea-text-14-400-white">気圧</span>
      </vs-col>
    </vs-row>
    <!-- <weather-contour/> -->
    <div id="item-contour">
      <vs-row vs-type="flex" class="mt-4 mb-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="8"
        >
          <span class="aisea-text-14-400-white">海面更正気圧線</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch v-model="toBeShowContour" :color="AISEA_COLOR.BLUE"/>
        </vs-col>
      </vs-row>
    </div>

    <vs-divider class=" mb-0" :color="AISEA_COLOR.GRAY"/>

    <vs-row vs-type="flex" class="mt-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="8"
      >
        <span class="aisea-text-14-400-white">リアルタイム予測表示</span>
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-w="4"
      >
        <vs-switch v-model="isTimeSync" :disabled="!(showMetocean || showContour)" :color="AISEA_COLOR.BLUE"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
//Mixins
import {ColorMixin, MetoceanMixin} from "@/mixins";

export default {
  mixins: [ColorMixin, MetoceanMixin],
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#item-metocean {
  input[type=radio] {
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    top: -2px;
    right: 0;
    bottom: 0;
    left: 0;
    height: 20px;
    width: 20px;
    vertical-align: -0.8rem;
    transition: all .15s ease-out 0s;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    outline: none;
    border-radius: 10%;
  }

  input[type=radio] {
    border-radius: 50%;
    background: $aisea-light-white;
  }

  input[type=radio]:checked:before {
    transform: scale(1);
  }

  input[type=radio]:before {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 3px;
    transform: scale(0);
    transition: all ease-out 250ms;
  }

  input[type=radio].blue {
    border: 2px solid $aisea-light-white;
  }

  input[type=radio].blue:checked {
    border: 2px solid $aisea-blue;
  }

  input[type=radio].blue:checked:before {
    background: $aisea-blue;
  }

  input[type=radio].blue:disabled {
    background:$aisea-mouse-gray;
    border: 2px solid $aisea-mouse-gray;
  }

  .metocean-radio-flex-container {
    display: flex;
    flex-flow: row wrap;
  }

}

</style>
